import { PageHeader } from "@/components/layout/PageHeader";
import { ActionInbox } from "@/components/shared/ActionInbox";
import { Loading } from "@/components/shared/Loading";
import { useActions, useMe } from "@/api/hooks";

export default function ManagementMyDay() {
  const { data: actions, isLoading } = useActions("management");
  const { data: me } = useMe();
  if (isLoading || !actions || !me) return <Loading />;
  const open = actions.filter((item) => !item.done);
  const approvals = open.filter((item) => item.tag === "Approval").length;
  const exceptions = open.filter((item) => item.tag === "Exception").length;
  const closures = open.filter((item) => item.tag === "Closure").length;

  return (
    <>
      <PageHeader title="My Day" subtitle={`${open.length} cross-functional item${open.length === 1 ? "" : "s"} awaiting review`} />
      <div className="flex-1 overflow-y-auto">
        <div className="px-4 pt-5 md:px-6">
          <div className="rounded-xl border border-slate-200 bg-white p-4">
            <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">Management overview</div>
            <div className="mt-1 text-sm text-slate-700">{me.user.name}, your live queue contains <strong>{approvals} approval{approvals === 1 ? "" : "s"}</strong>, <strong>{exceptions} exception{exceptions === 1 ? "" : "s"}</strong>, and <strong>{closures} closure{closures === 1 ? "" : "s"}</strong> ready for archival review.</div>
          </div>
        </div>
        <div className="px-4 pb-1.5 pt-5 text-[11px] font-semibold uppercase tracking-wider text-slate-400 md:px-6">Action inbox</div>
        <div className="mx-4 mb-6 overflow-hidden rounded-xl border border-slate-200 bg-white md:mx-6"><ActionInbox items={actions} /></div>
      </div>
    </>
  );
}
